<template>
    <div>

        <b-row class="d-flex flex-column flex-md-row justify-content-between align-items-center">

            <b-col sm="6">
                <b-form-group>
                    <b-input-group>
                        <b-form-input v-model="filterSites.search" name="search" type="text" placeholder="Buscar..." />
                        <b-input-group-append>
                            <b-button @click="searchSite" variant="primary" class="ml-2 btn-search">
                                <i class="fa fa-search fa-lg" />
                                <span class="d-none d-md-inline-block">Buscar</span>
                            </b-button>
                            <b-button @click="clearFilter" class="ml-2 btn-clear">
                                <i class="fa fa-eraser fa-lg" />
                                <span class="d-none d-md-inline-block"> Limpiar</span>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

            </b-col>

            <b-col v-if="validarPermisoComponente('empresa-editar-locaciones')" class="mb-2" sm="6">
                <b-button @click="openCreate" variant="primary" class="float-right">
                    Crear Locación
                </b-button>
            </b-col>

            <b-col sm="12">
                <b-table responsive striped hover empty-text="No hay locaciones para mostrar" show-empty
                    thead-tr-class="table-active" :items="sites.data" :fields="columns">

                    <template v-slot:cell(is_active)="data">
                        <span
                            v-html="$colorBadge(data.item.is_active ? 'success' : 'danger', data.item.is_active ? 'Activo' : 'Inactivo')"></span>
                    </template>

                    <template v-if="validarPermisoComponente('empresa-editar-locaciones')" v-slot:cell(actions)="data">

                        <el-tooltip placement="top" content="Editar">
                            <i @click="editSite(data.item.id)" class="fa fa-edit text-primary fa-lg mr-2"
                                style="cursor: pointer;" />
                        </el-tooltip>

                        <el-tooltip placement="top" :content="data.item.is_active ? 'Inactivar' : 'Activar'">
                            <i @click="changeStatus(data.item.id)"
                                :class="data.item.is_active ? 'fa fa-close text-danger fa-lg' : 'fa fa-check text-success fa-lg'"
                                style="cursor: pointer;" />
                        </el-tooltip>

                    </template>

                </b-table>
            </b-col>

            <b-col sm="12" md="2"
                class="mt-4 mt-md-0 d-flex justify-content-md-start justify-content-start align-items-start order-2 order-md-1">
                <b-button @click="backRoute" v-if="back" size="sm" variant="secondary" class="w-auto">
                    <i class="fa fa-reply fa-lg"></i>
                    Volver
                </b-button>
            </b-col>

            <b-col sm="12" md="10"
                class="d-flex justify-content-md-end justify-content-center align-items-center order-1 order-md-2 pr-4">
                <el-pagination style="max-width: 100%" v-model="filterSites.page" :total="filterSites.total"
                    :current-page="filterSites.page" :page-size="Number(filterSites.per_page)"
                    @size-change="afterChangeSizePagination" @current-change="afterChangePagePagination"
                    :page-sizes="[10, 30, 50, 100]" layout="total, sizes, prev, pager, next" />
            </b-col>

        </b-row>

        <b-modal id="modal-sites" :title="title" size="md" hide-footer @hidden="onModalHidden" no-close-on-backdrop>
            <SitesForm :modal="true" />
        </b-modal>

    </div>
</template>

<script>
import SitesForm from './Form.vue'
import { mapMutations, mapActions, mapState } from 'vuex';
import { validarPermisoComponente } from "@/plugins/acl";
export default {
    name: 'SitesIndex',
    props: {
        back: {
            type: Boolean,
            default: true
        }
    },
    components: {
        SitesForm
    },
    data() {
        return {
            company_id: this.$route.params.id,
            title: 'Crear Locación',
            validarPermisoComponente: validarPermisoComponente,
        }
    },
    computed: {
        ...mapState('sites', [
            'sites',
            'filterSites',
        ]),

        columns() {
            const columnasBase = [
                {
                    key: "name",
                    label: "Nombre",
                    sortable: false,
                    thStyle: "'width: 500px;  'max-width: 500px;",
                },
                {
                    key: "description",
                    label: "Descripción",
                    sortable: false,
                    thStyle: "width: 500px; max-width: 500px;",
                },
                {
                    key: "is_active",
                    label: "Estado",
                    sortable: false,
                },
            ];

            if (this.validarPermisoComponente('empresa-editar-locaciones')) {
                columnasBase.push({
                    key: "actions",
                    label: "Acciones",
                    sortable: false,
                });
            }

            return columnasBase;
        },
    },
    async mounted() {
        await this.listSites({ company_id: this.company_id });
    },
    methods: {
        ...mapMutations('sites', [
            'setSiteDefault',
            'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination',
            'setDefaultFilterSites',
        ]),
        ...mapActions('sites', [
            'listSites',
            'changeStatusSite',
            'showSite',
        ]),

        openCreate() {
            this.title = 'Crear Locación';
            this.$bvModal.show('modal-sites');
        },

        onModalHidden() {
            this.setSiteDefault();
        },

        backRoute() {
            const currentPath = this.$route.path;
            if (currentPath.includes("/my-company")) {
                this.$router.go(-1);
            } else {
                this.$router.push("/empresas");
            }
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.listSites({ company_id: this.company_id });
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.listSites({ company_id: this.company_id });
        },

        async searchSite() {
            await this.listSites({ company_id: this.company_id, reloadPage: true });
        },

        async clearFilter() {
            this.setDefaultFilterSites();
            await this.listSites({ company_id: this.company_id });
        },

        async changeStatus(id) {
            await this.changeStatusSite({ company_id: this.company_id, id });
            await this.listSites({ company_id: this.company_id });
        },

        async editSite(id) {
            this.title = 'Editar Locación';
            await this.showSite({ company_id: this.company_id, id });
            await this.$bvModal.show('modal-sites');
        }
    }
}

</script>
